<template>
  <div class="cover-content table-wrapper">
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right"
    >
      <Row :gutter="16">
        <Col span="6">
          <FormItem label="推送平台:">
            <Select
              v-model="formInline.systemId"
              :clearable="false"
              placeholder="请选推送平台"
            >
              <Option
                v-for="(item, index) in pushList"
                :value="item.id"
                :key="index"
                >{{ item.systemName }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="推送内容:">
            <Select
              v-model="formInline.dataType"
              placeholder="请选择推送内容"
              filterable
              label-in-value
              @on-change="changeSelect"
            >
              <Option
                v-for="item in pushContentObj"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="推送类型:">
            <Select
              v-model="formInline.pushOperationType"
              placeholder="请选择推送类型"
              filterable
            >
              <Option
                v-for="item in pushTypeObj"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="推送时间:">
            <DatePicker
              type="daterange"
              placeholder="请选择推送时间"
              v-model="formInline.pushDate"
              style="width: calc(100% - 12px); margin-right: 12px"
              @on-change="handlePushDateChange"
            ></DatePicker>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="所属项目:">
            <Input
              v-model="formInline.projectName"
              placeholder="请输入项目名称"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目所在地:">
            <!-- <place-select v-model="formInline.areaCode"></place-select> -->
            <Cascader :data="counties" @on-change="handleChange" v-model="formInline.areaCodes" clearable placeholder="请选择地区" change-on-select></Cascader>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目状态:">
            <Select
              v-model="formInline.prjStatus"
              placeholder="请选择项目状态"
              filterable
            >
              <Option value="">全部</Option>
              <Option value="001">筹备</Option>
              <Option value="002">立项</Option>
              <Option value="003">在建</Option>
              <Option value="003">竣工</Option>
              <Option value="005">停工</Option>
              <Option value="004">完工</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="处理状态:">
            <Select
              v-model="formInline.handleStatus"
              placeholder="请选择处理状态"
              filterable
            >
              <Option
                v-for="item in dealStatueObj"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="24">
        <Col class="high-search" :span="24">
          <FormItem :label-width="0" style="text-align: right;">
            <Button type="primary" @click="handleQuery">搜索</Button>
            <Button style="margin-left: 20px" @click="handleReset">重置</Button>
            <span
              :class="open ? 'search-open' : 'search-close'"
              @click="open = !open"
              >{{ open ? "收起" : "展开" }}
              <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
            /></span>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="8">
          <!-- :disabled="disabledPush" -->
          <!-- <Button
            style="margin-bottom: 24px; margin-right: 16px"
            type="primary"
            @click="handleBatchPush"
            >推送</Button
          > -->
          <Button
            :loading="eLoading"
            style="margin-bottom: 24px"
            icon="ios-exit-outline"
            @click="handleExport"
            :disabled="disabledExport"
            >导出</Button
          >
        </Col>
      </Row>
    </Form>
    <div class="cover-table">
      <Table
        border
        style="width: 100%"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
        ref="selection"
        @on-selection-change="handleSelect"
      >
        <template slot-scope="{ row, index }" slot="action">
          <!-- <span
            class="pointer"
            @click="handlePush(row)"
            style="display: inline-block; margin-right: 8px"
            >重新推送</span
          > -->
          <span
            v-if="row.dataType != 'corp'"
            class="pointer"
            @click="
              handleDeal('dataPushDetails', row.projectId, row.projectName)
            "
            >推送明细</span
          >
        </template>
      </Table>
      <Page
        class="page"
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
  </div>
</template>
<style scoped>
.marL {
  width: 100%;
  height: 32px;
}
.marL >>> .el-input__inner {
  display: inline-block;
  height: 32px;
}
.marL >>> .el-icon-date {
  margin-left: -9px;
  font-size: 14px;
  /* margin-top:-8px; */

  color: #c0c4cc;
  float: left;
  line-height: 32px;
}
.marL >>> .el-range-separator {
  margin-top: -8px;
  display: inline-block;
  width: 16%;
}
.marL >>> .el-range__close-icon {
  margin-top: -8px;
}
.marL >>> .el-input__suffix .el-input__icon {
  height: 32px;
  line-height: 32px;
}
</style>
<script>
import { mapState, mapActions } from "vuex";
import tableMixin from "@/components/tableMixin";

export default {
  mixins: [tableMixin],
  data() {
    return {
      eLoading: false,
      loading: false,
      open: false,
      pushContentObj: [], // 推送内容
      pushTypeObj: [], // 推送类型
      dealStatueObj: [], // 处理状态
      formInline: {
        size: 10,
        current: 1,
        systemId: "", //推送平台
        dataType: "", // 推送内容
        pushOperationType: "", // 推送类型
        pushDate: [], // 推送时间
        endDate: "", // 结束时间
        startDate: "", // 开始时间
        projectName: "", // 项目名称
        areaCodes: [], // 地区
        prjStatus: "", // 项目状态
        handleStatus: "", // 处理状态
      },
      pageSize: 10,
      page: 1,
      tableColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        { title: "失败原因", key: "message", minWidth: 210, tooltip: true },
        {
          title: "推送内容",
          key: "dataTypeStr",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "失败数据",
          key: "sendDataDetails",
          minWidth: 210,
          tooltip: true,
        },
        { title: "推送类型", key: "operationTypeStr", minWidth: 100 },
        { title: "推送时间", key: "createTime", minWidth: 210, tooltip: true },
        { title: "所属项目", key: "projectName", minWidth: 210, tooltip: true },
        { title: "项目所在地", key: "areaName", minWidth: 210, tooltip: true },
        { title: "项目状态", key: "prjStatus", minWidth: 100 },
        {
          title: "异步请求结果",
          key: "asyncResultStr",
          minWidth: 125,
          tooltip: true,
        },
        {
          title: "处理状态",
          key: "handleStatusStr",
          minWidth: 100,
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          align: "center",
          minWidth: 180,
        },
      ],
      tableData: [],
      //推送系统列表
      pushList: [],
      disabledExport: true, // 是否可导出
      //   disabledPush: true, // 是否可推送
      selectionData: [], // 选中的数据
      exportLabel: "", // 导出的推送内容名
    };
  },
  computed: {
    ...mapState(["navList", "area", "citys", 'counties']),
  },
  created() {
    this.getDict();
    this.getPushList();
  },
  mounted() {
    this.GetCounties(localStorage.getItem('tenantAreaCode'));
  },
  watch: {},
  methods: {
    ...mapActions(['GetCounties']),
    // 获取字典值
    getDict() {
      // 推送内容
      this.getPushContentDict();
      // 推送类型
      this.getPushTypeDict();
      //   处理状态
      this.getStatueDict();
    },
    // 推送内容
    getPushContentDict() {
      this.axios({
        method: "post",
        url: "/pushOperation/dataTypeDict",
      }).then((res) => {
        if (res.data.success) {
          this.pushContentObj = res.data.data;
        }
      });
    },
    // 推送类型
    getPushTypeDict() {
      this.axios({
        method: "post",
        url: "/pushOperation/operationTypeDict",
      }).then((res) => {
        if (res.data.success) {
          this.pushTypeObj = res.data.data;
        }
      });
    },
    // 处理状态
    getStatueDict() {
      this.axios({
        method: "post",
        url: "/pushOperation/handleStatueDict",
      }).then((res) => {
        if (res.data.success) {
          this.dealStatueObj = res.data.data;
        }
      });
    },
    // 推送内容change
    changeSelect(val) {
      if (this.formInline.dataType && val && val.value) {
        this.disabledExport = false;
        this.exportLabel = val.label;
      } else {
        this.disabledExport = true;
      }
    },
    // 获取推送平台列表
    getPushList() {
      this.axios({
        method: "get",
        url: "/push/pushSystemInfo",
      }).then((res) => {
        this.pushList = res.data.data;
        this.formInline.systemId = this.pushList.length
          ? this.pushList[0].id
          : "";
        this.getTableDatas();
      });
    },
    handlePushDateChange(val) {
      this.formInline["startDate"] = val[0];
      this.formInline["endDate"] = val[1];
    },
    // 搜索
    handleQuery() {
      this.pageSize = 10;
      this.page = 1;
      this.getTableDatas();
    },
    // 重置
    handleReset() {
      this.pageSize = 10;
      this.page = 1;
      Object.assign(this.$data.formInline, this.$options.data().formInline);
      this.formInline.systemId = this.pushList.length
          ? this.pushList[0].id
          : "";
      this.getTableDatas();
    },
    // 导出
    handleExport() {
      const {
        systemId,
        dataType,
        pushOperationType,
        endDate,
        startDate,
        projectName,
        areaCodes,
        prjStatus,
        handleStatus,
      } = this.formInline;
      this.eLoading = true;
      this.axios({
        method: "post",
        url: "/pushOperation/exportPushFailPageList",
        responseType: "arraybuffer",
        data: {
          pageSize: this.pageSize,
          pageNo: this.page,
          systemId,
          dataType,
          pushOperationType,
          endDate,
          startDate,
          projectName,
          areaCode: areaCodes.length ? areaCodes[areaCodes.length -1] : '',
          prjStatus,
          handleStatus,
        },
      })
        .then((response) => {
          this.eLoading = false;
          this.common.download(
            response,
            `数据推送失败清单-${this.exportLabel}.xls`,
            "application/vnd.ms-excel"
          );
        })
        .catch(() => {
          this.eLoading = false;
        });
    },
    /*处理操作 - 推送明细*/
    handleDeal(name, projectId, projectName) {
      console.log(name, projectId, projectName);
      this.$router.push({
        name: name,
        query: {
          projectId: projectId,
          projectName: projectName,
        },
      });
    },
    /*处理操作 - 单个重新推送*/
    handlePush(row) {
      this.pushData([row.projectCode]);
    },
    /*处理操作 - 批量重新推送*/
    handleBatchPush() {
      let ids = this.selectionData.map((item) => {
        return item.projectCode;
      });
      if (this.selectionData.length) {
        this.pushData(ids);
      } else {
        this.$Message.info("请选择数据！");
      }
    },
    pushData(ids) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定要推送该信息吗？",
        onOk: () => {
          this.axios({
            method: "post",
            url: "/project/secretKey/disabled",
            data: {
              id: ids,
            },
          }).then((res) => {
            if (res.data.success) {
              this.$Message.success({
                content: "操作成功",
              });
              this.getTableDatas();
            } else {
              this.$Message.warning({
                content: "操作失败",
              });
            }
          });
        },
        onCancel: () => {},
      });
    },
    // 表格选中
    handleSelect(selection) {
      for (let j = 0; j < this.tableData.length; j++) {
        if (selection.length === 0) {
          this.tableData[j]._checked = false;
          continue;
        }
        for (let i = 0; i < selection.length; i++) {
          if (selection[i].id === this.tableData[j].id) {
            this.tableData[j]._checked =
              selection[i].id === this.tableData[j].id;
            break;
          } else {
            this.tableData[j]._checked = false;
          }
        }
      }
      this.selectionData = selection;
      //   this.disabledPush = !this.selectionData.length;
    },
    /*获取表格数据*/
    getTableDatas() {
      const {
        systemId,
        dataType,
        pushOperationType,
        endDate,
        startDate,
        projectName,
        areaCodes,
        prjStatus,
        handleStatus,
      } = this.formInline;
      this.loading = true;
      this.axios({
        method: "post",
        url: "/pushOperation/pushFailPageList",
        data: {
          pageSize: this.pageSize,
          pageNo: this.page,
          systemId,
          dataType,
          pushOperationType,
          endDate,
          startDate,
          projectName,
          areaCode: areaCodes.length ? areaCodes[areaCodes.length -1] : '',
          prjStatus,
          handleStatus,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePage(val) {
      this.page = val;
      this.getTableDatas();
    },
    pageSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getTableDatas();
    },
    handleChange(data, selectedData){ 
      this.formInline.areaCodes = data;
    }
  },
};
</script>